<div class="hb-container hb-container--width-lg">
  <div class="hb-grid hb-mb--xl">
    <div class="hb-cell hb-cell--12of12 hb-cell--3of12@md">
      <stat-filter (selectedFilters)="filterVisning($event)" seksjon="kommuneside"></stat-filter>
    </div>
    <div class="hb-cell hb-cell--12of12 hb-cell--9of12@md">
      <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Historisk utvikling</h1>
      <hb-accordion class="hb-mb--lg">
        <hb-accordion-element id="historiskUtviklingID">
          <h2 title class="hb-accordion-tittel">Om historisk utvikling</h2>
          <div body="">
            <p>Denne siden gir deg mulighet til å se utviklingen i nøkkeltall over en valgt periode for en eller flere kommuner.</p>
            <p>Du kan sortere tabellinnholdet etter størrelse ved å tykke på kolonneoverskriftene.</p>
            <p><strong>Merk:</strong> Dersom det er færre enn 4 observasjoner vises ikke detaljene for alle ordningene. Dette er for å ivareta personvernhensynet.</p>
          </div>
        </hb-accordion-element>
      </hb-accordion>

      <div class="hb-grid">
        <ng-container>
          <stat-qlik-table
            id="hovedtall-startlån-pr-år"
            class="hb-cell hb-cell--12of12"
            [omHovedtall]="'Tabellen viser nøkkeltall for startlån '"
            [visExcel]="true"
            [valgtFilter]="valgtFilter"
            [noSelections]="true"
          >
          </stat-qlik-table>
          <stat-qlik-table
            id="hovedtall-bostøtte-pr-år"
            class="hb-cell hb-cell--12of12"
            [omHovedtall]="'Tabellen viser nøkkeltall for bostøtte '"
            [visExcel]="true"
            [valgtFilter]="valgtFilter"
            [noSelections]="true"
          >
          </stat-qlik-table>
          <stat-qlik-table
            id="hovedtall-lån-og-tilskudd-pr-år"
            class="hb-cell hb-cell--12of12"
            [omHovedtall]="'Tabellen viser nøkkeltall for kommunalt disponerte boliger'"
            [visExcel]="true"
            [valgtFilter]="valgtFilter"
            [noSelections]="true"
          >
          </stat-qlik-table>
        </ng-container>
      </div>
    </div>
  </div>
</div>
